import thunkMiddleware from 'redux-thunk';
import { createStore, applyMiddleware } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web

import rootReducer from '../_reducers';

let middleware = [thunkMiddleware];

if (process.env.NODE_ENV === 'development') {
  const { logger } = require(`redux-logger`);

  middleware.push(logger);
}

const persistConfig = {
  key: 'axs-session',
  storage,
  whitelist: ['authentication', 'client', 'user'],
}

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = createStore(
  persistedReducer,
  applyMiddleware(...middleware)
);

export const persistor = persistStore(store);